import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { getDatasetUrlParams } from '../../../utils/getDatasetUrlParams';
import { useDatasetContext } from '../../../hooks/context/useDatasetContext';

export const useInterDatasetGuard = () => {
  const history = useHistory();
  const { dataset } = useDatasetContext();

  // Handle redirect via back/forward button between datasets including filter first datasets.
  useEffect(() => {
    const unblock = history.block((target, action) => {
      if (action === 'POP') {
        const from = getDatasetUrlParams(history.location.pathname);
        const to = getDatasetUrlParams(target.pathname);
        const isObject = typeof target.state === 'object';

        const isInterdatasetPop =
          from.datasetId !== undefined &&
          to.datasetId !== undefined &&
          from.datasetId !== to.datasetId;
        const isFromFilterPath = history.location.pathname.endsWith('/filter');
        const isFilterFirstDataset = dataset?.filterFirst !== undefined;

        const shouldForceFindInDataset =
          (isFromFilterPath &&
            isInterdatasetPop &&
            isFilterFirstDataset &&
            to.itemId !== undefined) ||
          (!isFromFilterPath && isInterdatasetPop && to.itemId !== undefined);

        // Add flag to session, that will be consumed after redirect.
        // Row should be found and fetched.
        if (shouldForceFindInDataset) {
          target.state = {
            ...((isObject ? target.state : {}) as Record<string, unknown>),
            forceFindInDataset: true,
          };
        }
      }

      return undefined;
    });

    return unblock;
  }, [history, dataset]);
};
